var map = {
	"./DSC_0059-1024x683.jpg": 5710,
	"./DSC_0061-1024x683.jpg": 1578,
	"./DSC_0070-1024x683.jpg": 6467,
	"./DSC_0071-1024x683.jpg": 2308,
	"./DSC_0078-1024x683.jpg": 3131,
	"./DSC_0082-1024x683.jpg": 3510,
	"./DSC_0084-1024x683.jpg": 592,
	"./DSC_0085-1024x683.jpg": 607
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 6631;